export const sortTree = (tree) => {
  return Object.keys(tree).sort().reduce((obj, key) => {
      obj[key] = tree[key];
      return obj;
    },
    {}
  );
}
